import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import KolkataMain from "../Component/kolkata/AboutMain";
import WhoWeAre from "./kolkata/WhoWeAre";
import WhyStudyMbbsAbroad from "src/Kolkata/WhyStudyMbbsAbroad";
import Banner from "src/Kolkata/Banner";
import OurValue from "./kolkata/Value";
import ImmigrationQuestions from "src/Kolkata/ImmigrationFaq";
import Milestones from "src/Component/mildstones/Milestones";
import { useEffect } from "react";
import { Box } from "@mui/material";
import { Helmet } from "react-helmet";
import Roadmap from "src/Component/services/Roadmap";
import LetsGetStarted from "src/Component/LetsGetStarted";
import StudyAbroadGlobalCombination from "src/CountryPages/StudyAbroadMainComponents/StudyAbroadGlobalCombination";
const Kolkata = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {" "}
      <Helmet>
        <title>
        Study Abroad Consultants in Kolkata | Taksheela Institute
        </title>
        <meta
          name="description"
          content="Looking for study abroad consultants in Kolkata? Taksheela Institute offers expert guidance for admissions, test prep, & achieving your global education dreams."
        />
        <meta
          name="keywords"
          content="Study Abroad Consultants in Kolkata, Overseas Education Consultants in Kolkata, MBBS Abroad Consultants in Kolkata, MBBS study abroad consultancy in Kolkata, Overseas MBBS Consultant in Kolkata"
        />
      </Helmet>
      <Navbar />
      <Banner />
      <KolkataMain />
      <WhoWeAre />
      <OurValue />
      {/* <KolkataAdvantage /> */}
      <WhyStudyMbbsAbroad />
      <Milestones />
      <Roadmap />
      <StudyAbroadGlobalCombination />
      <Box sx={{ margin: "50px 0" }}>
          <ImmigrationQuestions />
      </Box>
      <LetsGetStarted />
      <Box paddingTop={"30px"}>
        <Footer />
      </Box>
    </>
  );
};

export default Kolkata;
